module.exports = __webpack_public_path__ + "static/media/Maf_13Agosto.e1b267d2.jpg";